import { Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import useAuthContext from '../../apps/common/modules/auth/hooks/useAuthContext';
import { SideNavItems } from '../../utils/constants/RoleConstants';
import { INavItemDetail } from '../../utils/Interface/NavInterface';
import Constants from '../../utils/Constants';
import { useAppDispatch, useAppSelector } from '../../Redux/Store';
import { setShouldAllowBuyPoPageChange } from '../../apps/shippingTracker/modules/BuyPo/actions/buyPoActions';
import { setShouldAllowShipPoPageChange } from '../../apps/shippingTracker/modules/shippo/reducers/shipPoReducer';

const SideNavBuyPO = () => {
    const { isAuthenticated, getUsersRoles } = useAuthContext();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { shouldAllowPageChange } = useAppSelector(state => state.buyPO);
    const { shouldAllowPageChange: shouldAllowShipPoPageChange } =
        useAppSelector(state => state.shipPO);

    const getNavItem = (navItemDetail: INavItemDetail) => {
        const navItemRoles = navItemDetail.roles;
        for (let roleIndex = 0; roleIndex < navItemRoles.length; roleIndex++) {
            if (getUsersRoles().includes(navItemRoles[roleIndex])) {
                return navItem(navItemDetail, roleIndex);
            }
        }
        return null;
    };

    const navItem = (navItemDetail: INavItemDetail, roleIndex: number) => {
        return (
            <span
                className="buypo-nav-subitem-link"
                key={roleIndex}
                onClick={() => handleClick(navItemDetail.redirectUrl)}
            >
                <li>{navItemDetail.label}</li>
            </span>
        );
    };

    const handleClick = (route: string) => {
        if (shouldAllowPageChange.lastUpdate) {
            dispatch(
                setShouldAllowBuyPoPageChange({
                    ...shouldAllowPageChange,
                    showModal: true,
                    route: route,
                }),
            );
        } else if (shouldAllowShipPoPageChange.lastUpdate) {
            dispatch(
                setShouldAllowShipPoPageChange({
                    ...shouldAllowShipPoPageChange,
                    showModal: true,
                    route: route,
                }),
            );
        } else {
            dispatch(
                setShouldAllowBuyPoPageChange({
                    ...shouldAllowPageChange,
                    showModal: false,
                    route: route,
                }),
            );
            navigate(route);
        }
    };

    return (
        <>
            {isAuthenticated() && (
                <Accordion className="accordion">
                    {SideNavItems.buyPoSideNavItem?.subBuyPoItemsPrimary?.map(
                        (navItem, index) => {
                            let component: JSX.Element | null = null;
                            for (let i = 0; i < navItem.roles.length; i++) {
                                if (
                                    getUsersRoles().includes(navItem.roles[i])
                                ) {
                                    component = (
                                        <Accordion.Item
                                            className="accordion-item"
                                            key={index}
                                            eventKey="-1"
                                        >
                                            <span
                                                onClick={() =>
                                                    handleClick(
                                                        navItem.redirectUrl,
                                                    )
                                                }
                                            >
                                                <Accordion.Header className="accordion-header">
                                                    {navItem.icon}
                                                    {navItem.label}
                                                </Accordion.Header>
                                            </span>
                                        </Accordion.Item>
                                    );
                                    break;
                                }
                            }
                            return component;
                        },
                    )}
                    {SideNavItems.buyPoSideNavItem?.subBuyPoItemsSecondary
                        ?.filter(
                            navItem =>
                                !navItem.authType ||
                                navItem.authType ===
                                    localStorage.getItem(
                                        Constants.StorageItems.AUTH_TYPE,
                                    ),
                        )
                        .map((navItem, index) => {
                            let component: JSX.Element | null = null;
                            for (let i = 0; i < navItem.roles.length; i++) {
                                if (
                                    getUsersRoles().includes(navItem.roles[i])
                                ) {
                                    component = (
                                        <Accordion.Item
                                            className="accordion-item"
                                            key={index}
                                            eventKey={index.toString()}
                                        >
                                            <Accordion.Header
                                                key={index}
                                                className="accordion-header"
                                            >
                                                {navItem.icon}
                                                {navItem.label}
                                            </Accordion.Header>
                                            <Accordion.Body className="accordion-body">
                                                {navItem.subSideNavItems?.map(
                                                    (
                                                        sideNavItemDetail: INavItemDetail,
                                                        subIndex: number,
                                                    ) => {
                                                        return sideNavItemDetail.isDisabled ? null : (
                                                            <Accordion.Item
                                                                className="accordion-subitem"
                                                                key={subIndex}
                                                                eventKey={subIndex.toString()}
                                                            >
                                                                {getNavItem(
                                                                    sideNavItemDetail,
                                                                )}
                                                            </Accordion.Item>
                                                        );
                                                    },
                                                )}
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    );
                                    break;
                                }
                            }
                            return component;
                        })}
                    {SideNavItems.buyPoSideNavItem?.subBuyPoItemsTertiary?.map(
                        (navItem, index) => {
                            let component: JSX.Element | null = null;
                            for (let i = 0; i < navItem.roles.length; i++) {
                                if (
                                    getUsersRoles().includes(navItem.roles[i])
                                ) {
                                    component = (
                                        <Accordion.Item
                                            className="accordion-item"
                                            key={index}
                                            eventKey="-1"
                                        >
                                            <span
                                                onClick={() =>
                                                    handleClick(
                                                        navItem.redirectUrl,
                                                    )
                                                }
                                            >
                                                <Accordion.Header className="accordion-header">
                                                    {navItem.icon}
                                                    {navItem.label}
                                                </Accordion.Header>
                                            </span>
                                        </Accordion.Item>
                                    );
                                    break;
                                }
                            }
                            return component;
                        },
                    )}
                </Accordion>
            )}
        </>
    );
};

export default SideNavBuyPO;
